import React from 'react';
import classNames from 'classnames';

import { Label } from '../label.component';

export type FieldLabelProps = React.ComponentProps<typeof Label>;

export const FieldLabel = (props: FieldLabelProps) => (
  <Label className={classNames(Boolean(props.children && 'mb-1'))} {...props} />
);
